import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { UpdateArtistPageSuccess } from '@webapp/store/artist/action-creators';
import { UPDATE_ARTIST_PAGE_SUCCESS } from '@webapp/store/artist/actions';

export const trackMicrositeUpdated = (action$: Observable<UpdateArtistPageSuccess>) =>
  action$.pipe(
    ofType(UPDATE_ARTIST_PAGE_SUCCESS),
    map((_) => {
      if (window.analytics) {
        window.analytics.track('Microsite Updated', {});
      }
    }),
    filter(() => false)
  )